import React, { Fragment, Suspense } from "react";
import Preloader from "../../elements/Preloader";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { base_url } from "../Constants";
const Breadcrumb = React.lazy(() => import("../../components/Breadcrumb"));
const OrderAdd = React.lazy(()=>import("../../components/Profile/AddOrder"))
const FooterBottomOne = React.lazy(() =>
  import("../../components/FooterBottomOne")
);
const FooterOne = React.lazy(() => import("../../components/FooterOne"));
const NavbarOne = React.lazy(() => import("../../components/NavbarOne"));
const SearchPopup = React.lazy(() => import("../../elements/SearchPopup"));
const Profile = () => {
  const {t,i18n} =  useTranslation();
  const setting =  useSelector(state=>state.settingData.data);
  
  return (
    <>
      <Fragment>
        <Suspense fallback={<Preloader />}>
          {/* Search Popup */}
          <SearchPopup />

          {/* Navbar One */}
          <NavbarOne />

          {/* Breadcrumb */}
          {setting&&<Breadcrumb header_bg={base_url+'/'+setting.order_bg} title={t('Orders')} />}
          

          {/* Breadcrumb */}
          {setting&&<OrderAdd />} 
          
          {/* Footer One */}
          <FooterOne />

          {/* Footer Bottom One */}
          <FooterBottomOne />
        </Suspense>
      </Fragment>
    </>
  );
};

export default Profile;
